export const GET_SCOREBOARD_START = 'GET_SCOREBOARD_START';
export const GET_SCOREBOARD_SUCCESS = 'GET_SCOREBOARD_SUCCESS';
export const GET_SCOREBOARD_FAIL = 'GET_SCOREBOARD_FAIL';
export const GET_SCOREBOARD_RESET = 'GET_SCOREBOARD_RESET';
